export default __webpack_public_path__ + "static/media/ic_sharetochat.fdebc012.svg";